// ProgressBar — "Question N of M" label plus a slim progress bar.

import { Progress } from '@/components/ui/progress'
import { getStoredLang } from '@/lib/api'
import { t } from '@/lib/i18n'

interface Props {
  current: number // 1-indexed
  total: number
}

export function ProgressBar({ current, total }: Props) {
  const safeTotal = Math.max(total, 1)
  const clamped = Math.min(Math.max(current, 0), safeTotal)
  const pct = Math.round((clamped / safeTotal) * 100)
  const lang = getStoredLang()
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs uppercase tracking-wide text-muted-foreground">
        <span>{t(lang, 'question_n_of_m', { n: clamped, m: safeTotal })}</span>
        <span>{pct}%</span>
      </div>
      <Progress value={pct} className="h-1.5" />
    </div>
  )
}
